import { render, staticRenderFns } from "./PlatformCheckboxCard.vue?vue&type=template&id=fd9bf4e2&scoped=true&"
import script from "./PlatformCheckboxCard.vue?vue&type=script&lang=js&"
export * from "./PlatformCheckboxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9bf4e2",
  null
  
)

export default component.exports